<template>
  <div>
    <el-dialog :title="'审核'" :visible.sync="detailVisible"
               width="55%" center>
      <el-steps :active="currentContent" align-center style="margin:20px 0">
        <el-step title="企业信息" icon="el-icon-office-building"/>
        <el-step title="产品相关" icon="el-icon-grape"/>
        <el-step title="经营信息" icon="el-icon-user"/>
        <el-step title="审核" icon="el-icon-coordinate"/>
      </el-steps>
      <el-card class="box-card" v-show="currentContent===1">
        <div slot="header" class="clearfix">
          <span>企业信息</span>
        </div>
        <el-form label-position="right" label-width="140px" :model="saveModel" :rules="rules" ref="myform">
          <el-form-item label="企业名称" prop="companyName">
            <el-input v-model="saveModel.companyName" placeholder="企业名称"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="briefAddress">
            <el-input v-model="saveModel.certCode" placeholder="124403*******86982"></el-input>
          </el-form-item>
          <el-form-item label="企业法人" prop="briefAddress">
            <el-input v-model="saveModel.companyUserName" placeholder="法人名称"></el-input>
          </el-form-item>
          <el-form-item label="企业经营地址" prop="briefAddress">
            <div class="block">
              <el-cascader
                  @change="handleChange"
                  :model="useAddress"
                  :value="useAddress"
                  :placeholder="placeholder"
                  :options="options"
                  :props="{ expandTrigger: 'hover' }"
                  filterable
                  clearable></el-cascader>
            </div>
          </el-form-item>
          <el-form-item label="企业经营详细地址" prop="briefAddress">
            <el-input v-model="saveModel.detailAddress" placeholder="中国广东省深圳市龙华区华盛路"></el-input>
          </el-form-item>
          <el-form-item label="企业类别" prop="briefAddress">
            <el-select v-model="saveModel.companyType" placeholder="请选择">
              <el-option
                  v-for="item in companyTypes"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业性质" prop="briefAddress">
            <el-select v-model="saveModel.companyNature" placeholder="请选择">
              <el-option
                  v-for="item in companyNatures"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="营业执照" prop="briefAddress">
            <Upload :uploadData="uploadData" ref="businessPath"></Upload>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card" v-show="currentContent===2">
        <div slot="header" class="clearfix">
          <span>产品相关</span>
        </div>
        <el-form label-position="right" label-width="180px" :model="saveModel" :rules="rules" ref="myform">
          <el-form-item label="上一年销售规模" prop="briefAddress">
            <el-input placeholder="请输入内容" v-model="saveModel.turnover">
              <template slot="append">万元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="主要消费群体" prop="briefAddress">
            <el-select v-model="saveModel.consumerGroups" placeholder="请选择">
              <el-option
                  v-for="item in priceLevels"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品主要市场" prop="majorMarkets">
            <el-input v-model="saveModel.majorMarkets" placeholder="北京市,深圳市,美国"></el-input>
          </el-form-item>
          <el-form-item label="产品层次" prop="productLevel">
            <el-checkbox v-for="item in productLevels" :key="item.name" v-model="useProductLevel"
                         :label="item.name"
                         border size="medium"></el-checkbox>
          </el-form-item>
          <el-form-item label="相关证书情况" prop="briefAddress">
            <el-switch v-model="saveModel.isRelevant" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="" prop="briefAddress" v-show="saveModel.isRelevant">
            <Upload :uploadData="uploadData" ref="relevant"></Upload>
          </el-form-item>
          <el-form-item label="是否支持一键代发" prop="briefAddress">
            <el-switch v-model="saveModel.isIssued" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="企业供应优质产品类别" prop="highQualityProductType">
            <el-select v-model="saveModel.highQualityProductType" placeholder="请选择">
              <el-option
                  v-for="item in highQualityProducts"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-tooltip class="item" effect="dark" content="《农业残留物监测报告》,其他报告" placement="top-start">
            <el-form-item label="农业残留物监测报告">
              <el-switch v-model="saveModel.isMonitoringReport" :active-value="1" :inactive-value="0"/>
            </el-form-item>
          </el-tooltip>
          <el-form-item label="" prop="isMonitoringReport" v-show="saveModel.isMonitoringReport===1">
            <Upload :uploadData="uploadData" ref="monitoringReportPath" :uploadType="'Array'"></Upload>
          </el-form-item>
          <el-form-item label="食品经营许可证">
            <el-switch v-model="saveModel.isFoodBusinessLicense" :active-value="1" :inactive-value="0"/>
          </el-form-item>
          <el-form-item label="" prop="briefAddress" v-show="saveModel.isFoodBusinessLicense===1">
            <Upload :uploadData="uploadData" ref="fodBusinessLicensePath"></Upload>
          </el-form-item>
          <el-form-item label="商标持有情况" prop="trademarkPath">
            <el-switch v-model="saveModel.isTrademark" :active-value="1" :inactive-value="0"/>
          </el-form-item>
          <el-form-item label="" prop="trademarkPath" v-show="saveModel.isTrademark===1">
            <Upload :uploadData="uploadData" ref="trademarkPath"></Upload>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card" v-show="currentContent===3">
        <div slot="header" class="clearfix">
          <span>经营信息</span>
        </div>
        <el-form label-position="right" label-width="180px" :model="saveModel" :rules="rules" ref="myform">
          <el-form-item label="备注" prop="briefAddress">
            <el-input
                disabled
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 10}"
                placeholder="备注"
                v-model="saveModel.remark">
            </el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="briefAddress">
            <el-input v-model="saveModel.contacts" placeholder="联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="briefAddress">
            <el-input v-model="saveModel.contactsPhoneNumber" placeholder="189****4127"></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card" v-show="currentContent===4">
        <div slot="header" class="clearfix">
          <span>审核结果</span>
        </div>
        <el-form label-position="right" label-width="180px" :model="saveModel" :rules="rules" ref="myform">
          <el-form-item label="审核结果">
            <div>
              <el-radio v-model="saveModel.status" value="SUCCESS" label="SUCCESS" border>同意
              </el-radio>
              <el-radio v-model="saveModel.status" value="FAILURE" label="FAILURE" border>拒绝
              </el-radio>
            </div>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card" v-show="currentContent===4 && saveModel.status==='SUCCESS'"
               style="margin-top: 10px">
        <div slot="header" class="clearfix">
          <span>仓库信息</span>
        </div>
        <el-form label-position="right" label-width="180px" :model="saveModel" :rules="repositoryRules"
                 ref="repositoryForm">
          <el-form-item label="仓库名称" prop="name">
            <el-input v-model="saveModel.name" placeholder="请输入仓库名称"></el-input>
          </el-form-item>
          <el-form-item label="登录名" prop="username">
            <el-input v-model="saveModel.username" placeholder="仓库管理系统登录名"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="saveModel.password" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="rePassword">
            <el-input v-model="saveModel.rePassword" type="password" placeholder="请输入确认密码"></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
                <el-button @click="currentContent=2" v-show="currentContent===1">产品相关 &gt;</el-button>
                 <el-button @click="currentContent=2" v-show="currentContent===3">&lt; 产品相关</el-button>
                <el-button @click="currentContent=1" v-show="currentContent===2">&lt; 企业信息</el-button>
                <el-button @click="currentContent=3" v-show="currentContent===2">经营信息 &gt;</el-button>
                <el-button @click="currentContent=3" v-show="currentContent===4">&lt; 经营信息</el-button>
                <el-button @click="currentContent=4"
                           v-show="currentContent===3">提交审核 &gt;</el-button>
                <el-button v-show="currentContent===4" @click="submitModel">提交</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import Upload from "@/components/upload";

export default {
  name: "supplier-detail",
  data() {
    return {
      currentContent: 1,
      useAddress: {},
      saveModel: {
        companyName: '',
        certCode: '',
        companyUserName: '',
        provinceId: '',
        cityId: '',
        countryId: '',
        detailAddress: '',
        companyType: '',
        companyNature: '',
        businessPath: '',
        turnover: '',
        consumerGroups: '',
        majorMarkets: '',
        productLevel: '',
        highQualityProductType: '',
        isMonitoringReport: 0,
        isFoodBusinessLicense: 0,
        isRelevant: 0,
        isIssued: 0,
        isTrademark: 0,
        foodBusinessLicensePath: '',
        relevantPath: '',
        trademarkPath: '',
        contacts: '',
        contactsPhoneNumber: '',
        userId: '',
        status: 'SUCCESS',
        remark: '',
      },
      companyNatures: [
        {name: "生产制造商"},
        {name: "经销商"},
        {name: "代理商"},
        {name: "原产地农产品"},
        {name: "原产地养殖"},
      ],
      useProductLevel: [],
      companyTypes: [
        {name: "公司"},
        {name: "个人经营"},
        {name: "合伙人"},
        {name: "国营"},
        {name: "社会组织"},
      ],
      highQualityProducts: [
        {name: "时令果蔬"},
        {name: "膳用药材"},
        {name: "肉禽蛋类"},
        {name: "粮油米面"},
        {name: "南北干货"},
      ],
      priceLevels: [
        {name: "低端"},
        {name: "中端"},
        {name: "高端"},
        {name: "中端和高端"},
      ],
      productLevels: [
        {name: "国家地理标识产品"},
        {name: "无公害产品"},
        {name: "绿色产品"},
        {name: "有机产品"},
      ],
      rules: {
        companyName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur"
          }
        ],
        certCode: [
          {
            required: true,
            message: "统一社会信用代码",
            trigger: "blur"
          }
        ],
      },
      repositoryRules: {
        name: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur"
          }
        ],
        username: [
          {
            required: true,
            message: "请输入登录名",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ],
        rePassword: [
          {
            required: true,
            message: "请确认密码",
            trigger: "blur"
          }
        ],
      },
      detailVisible: false,
      placeholder: "输入关键字可搜索",
      uploadData: {
        folder: 'supplier',
        fileNamePre: 'supplier',
      },
    }
  },
  created() {
    this.loadZone();
  },
  watch: {
    detailVisible: function (val, oldVal) {
      if (!val) {
       this.data=this.$options.data();
      }
    }
  },
  components: {Upload},
  methods: {
    handleChange(value) {
      this.saveModel.provinceId = value[1];
      this.saveModel.cityId = value[2];
      this.saveModel.countryId = value[3];
    },
    loadZone() {
      const _this = this;
      _this.$common.ajaxRequest({
        url: "/address/findTreeZone",
        success(response) {
          let items = response.items || [];
          let options = [];
          items.forEach((v, i) => {
            let item = {};
            let itemChilds = [];
            if (v.children) {
              v.children.forEach((cv, ci) => {
                let itemChild = {};
                let itemChildChilds = [];
                cv.children.forEach((ccv, cci) => {
                  let itemChildChild = {};
                  Object.assign(
                      itemChildChild,
                      {value: ccv.id},
                      {label: ccv.name}
                  );
                  itemChildChilds.push(itemChildChild);
                });
                Object.assign(
                    itemChild,
                    {value: cv.id},
                    {label: cv.name},
                    {children: itemChildChilds}
                );
                itemChilds.push(itemChild);
              });
            }
            Object.assign(
                item,
                {value: v.id},
                {label: v.name},
                {children: itemChilds}
            );
            options.push(item);
          });
          _this.options = options;
        }
      });
    },
    submitModel() {
      const _this = this;
      if (this.useProductLevel) {
        this.saveModel.productLevel = this.useProductLevel.join(",");
      }
      if (this.saveModel.isRelevant === 1 && _this.$refs.relevant) {
        this.saveModel.relevantPath = _this.$refs.relevant.getIconPath();
        if (!this.saveModel.relevantPath) {
          _this.$message({
            message: "请上传相关证书",
            type: "error",
            duration: 1000,
          });
        }
      }
      if (this.saveModel.isFoodBusinessLicense === 1 && _this.$refs.fodBusinessLicensePath) {
        this.saveModel.fodBusinessLicensePath = _this.$refs.fodBusinessLicensePath.getIconPath();
        if (!this.saveModel.fodBusinessLicensePath) {
          _this.$message({
            message: "食品经营许可证",
            type: "error",
            duration: 1000,
          });
        }
      }
      if (this.saveModel.isTrademark === 1 && _this.$refs.trademarkPath) {
        this.saveModel.trademarkPath = _this.$refs.trademarkPath.getIconPath();
        if (!this.saveModel.trademarkPath) {
          _this.$message({
            message: "请上传相关证书",
            type: "error",
            duration: 1000,
          });
        }
      }
      if (this.saveModel.isMonitoringReport === 1 && _this.$refs.monitoringReportPath) {
        this.saveModel.monitoringReports = _this.$refs.monitoringReportPath.getIconPath();
        if (!this.saveModel.monitoringReports) {
          _this.$message({
            message: "请上传相关证书",
            type: "error",
            duration: 1000,
          });
        }
      }
      let repositoryValidFlag = true
      if (this.$refs['repositoryForm'] && this.saveModel.status === 'SUCCESS') {
        this.$refs['repositoryForm'].validate((valid) => {
          repositoryValidFlag = valid
        })
      }
      if (!repositoryValidFlag) {
        _this.$message({
          message: "请填写仓库信息",
          type: "error",
          duration: 1000,
        });
        return false
      }
      _this.$common.ajaxRequest({
        url: "/supplier/saveAdminSupplier",
        data: _this.saveModel,
        contentType: "application/json",
        success(response) {
          _this.$message({
            message: "保存成功",
            type: "success",
            duration: 1000,
            onClose: function () {
              _this.detailVisible = false;
              _this.saveModel = {};
              _this.currentContent = 1;
              _this.submitQuery();
            }
          });
        }
      });
    },
    detail(_id) {
      const _this = this;
      _this.$common.ajaxRequest({
        url: '/supplier/detailSupplier',
        data: {
          supplierId: _id
        },
        type: 'post',
        success(response) {
          _this.saveModel = response.item || {}
          _this.useAddress = ['100000', _this.saveModel.provinceId, _this.saveModel.cityId, _this.saveModel.countryId];
          _this.useProductLevel = _this.saveModel.productLevel.split(",");
          if (_this.$refs.businessPath) {
            _this.$refs.businessPath.loadIconPath(_this.saveModel.businessPath);
          }
          if (_this.saveModel.isRelevant === 1 && _this.$refs.relevant) {
            _this.$refs.relevant.loadIconPath(_this.saveModel.relevantPath);
          }
          if (_this.saveModel.isFoodBusinessLicense === 1 && _this.$refs.fodBusinessLicensePath) {
            _this.$refs.fodBusinessLicensePath.loadIconPath(_this.saveModel.fodBusinessLicensePath);
          }
          if (_this.saveModel.isTrademark === 1 && _this.$refs.trademarkPath) {
            _this.$refs.trademarkPath.loadIconPath(_this.saveModel.trademarkPath);
          }
          _this.detailVisible = true;
        }
      })
    },
    openWindow(_supplierId) {
      if (_supplierId) {
        this.detail(_supplierId)
      }
    },
  }
}
</script>

<style scoped>

</style>